import { useContext, useState } from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import { Form } from 'react-bootstrap';
import Button from '@mui/material/Button';
import { AuthContext } from "../context/AuthContext";
import axios from 'axios';

const SwitchAccount = ({open, onClose}) => {

    const {createNewIntegrations, fetchUserData, integrationsParams, aiSettings, setUserData} = useContext(AuthContext)
    const [searchQuery, setSearchQuery] = useState(''); 
    const [activeMenu, setActiveMenu] = useState("option1");
    const [selectedWidget, setSelectedWidget] = useState(null);
    const [loading, setLoading] = useState(false);
    const [apiKey, setApiKey] = useState('');
    const [secretKey, setSecretKey] = useState('');
    const [errors, setErrors] = useState({ api: '', secret: '' });

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const widgetsByOption = {
        option1: [
            { src: 'traditional_charles.svg', label: 'Charles Schwab', key: 'traditional', height: 3, width: 2 },
            { src: 'merill.svg', label: 'Merill Lynch', key: 'traditional', height: 3, width: 2 },
            { src: 'morgan.svg', label: 'Morgan Stanley', key: 'traditional', height: 3, width: 2 },
            { src: 'jp_morgan.svg', label: 'J.P.Morgan', key: 'traditional', height: 3, width: 2 },
            { src: 'td.svg', label: 'TD', key: 'traditional', height: 3, width: 2 },
            { src: 'wells.svg', label: 'Wells Fargo', key: 'traditional', height: 3, width: 2 },
            { src: 'citi.svg', label: 'CITI', key: 'traditional', height: 3, width: 2 },
        ],
        option2: [
            { src: 'thirdp_ib.svg', label: 'Interactive Brokers', key: 'thirdp', height: 1, width: 1 },
            { src: 'etrade.svg', label: 'E*Trade', key: 'thirdp', height: 1, width: 1 },
            { src: 'trade_station.svg', label: 'Trade Station', key: 'thirdp', height: 1, width: 1 },
            { src: 'webull.svg', label: 'Webull', key: 'thirdp', height: 1, width: 1 },
            { src: 'robin_hood.svg', label: 'Robinhood', key: 'thirdp', height: 1, width: 1 },
            { src: 'tastytrade.svg', label: 'Tastytrade', key: 'thirdp', height: 1, width: 1 },
            { src: 'bloomberg.svg', label: 'Bloomberg', key: 'thirdp', height: 1, width: 1 },
        ],
        option3: [
            { src: 'crypto_coin.svg', label: 'Coinbase', key: 'crypto', height: 1, width: 1 },
            { src: 'crypto.svg', label: 'Crypto.com', key: 'crypto', height: 1, width: 1 },
            { src: 'binance.svg', label: 'Binance', key: 'crypto', height: 1, width: 1 },
            { src: 'kraken.svg', label: 'Kraken', key: 'crypto', height: 1, width: 1 },
            { src: 'gemini.svg', label: 'Gemini', key: 'crypto', height: 1, width: 1 },
        ]
    };

    const handleWidgetClick = (widget) => {
        setSelectedWidget(widget);
    };

    const handleCloseSecondDialog = () => {
        setSelectedWidget(null);
        setApiKey('');
        setSecretKey('');
        // setErrors('');
        setLoading(false);
    };

    const renderContent = () => {
        const filteredWidgets = widgetsByOption[activeMenu]?.filter(widget =>
            widget.label.toLowerCase().includes(searchQuery) // Filter based on search query
        ) || [];
    
        return (
            <div className="content-area" style={{ display: 'flex', flexWrap: 'wrap' }}>
                {filteredWidgets.map((widget, index) => {
    
                    return (
                        <div 
                            key={index} 
                            className="widget-container" 
                            style={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: 'center', 
                                margin: '15px', 
                                position: 'relative', 
                                width: '140px',
                            }} 
                            onClick={() => handleWidgetClick(widget)}
                        >
                            <img
                                style={{ width: "80px" }}
                                src={`${process.env.PUBLIC_URL}/images/switch_acc/${widget.src}`}
                                alt={widget.label}
                                className="customize-icon"
                                role="button"
                            />
                            <div style={{ marginTop: '5px', fontSize: '14px' }}>
                                {widget.label}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };
    
    
    const hendleKeySubmit = async (event) => {
        event.preventDefault();
        const selectedName = selectedWidget.label.replace(/\s+/g, '');
        // let valid = true;

        // let newErrors = { ...errors };

        // if (!apiKey) {
        //     newErrors.api = 'API Key is required.';
        //     valid = false;
        // } else if (!secretKey) {
        //     newErrors.secret = 'Secret Key is required.';
        //     valid = false;
        // }else {
        //     newErrors.api = '';
        //     newErrors.secret = '';
        // }

        // setErrors(newErrors);
        setLoading(true);

        const response = await createNewIntegrations(selectedName,apiKey,secretKey,'');
        
        if(response.message === 'Integration added successfully'){
            setLoading(false);
            // setErrors('');
            setApiKey('');
            setSecretKey('');
            handleCloseSecondDialog();
            const response = await fetchUserData();
            const name = selectedWidget.label.replace(/\*/g, '').toLowerCase();
            if(!response.integrations){
                const updatedSettings = {
                    ...(Object.keys(integrationsParams).length > 0
                    ? integrationsParams
                    : response.integrations?.current_integration || {}),
                    current_integration: name,
                };
                await aiSettings(updatedSettings);
            }
        }
            
    }

    const handleFirstDialogClose = async () => {
        const token = localStorage.getItem('accessToken');
        const userId = localStorage.getItem('userId');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        setUserData(response.data);
        onClose();
    };
    

    return (
        <>
            <Dialog
                open={open} onClose={onClose}
                aria-labelledby="settings-dialog-title"
                fullWidth
                PaperProps={{
                    style: {
                        width: '800px',
                        maxWidth: '100%',
                    },
                }}
                className="setting-dialog"
            >
                <DialogTitle id="settings-dialog-title" className="d-flex justify-content-between mb-2">
                    Link account
                    <img
                        style={{ height: "22px", width: "20px", cursor: "pointer" }}
                        src={`${process.env.PUBLIC_URL}/images/close.png`}
                        alt="close"
                        onClick={handleFirstDialogClose}
                    />
                </DialogTitle>
                <div className="dialog-body">
                    <div className="switch_acc_sidebar">
                        <Form>
                            <FormControl className="square-form-control-search m-0" sx={{ m: 1, minWidth: 120 }} style={{ textAlign: 'left' }}>
                                <TextField
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={handleSearchChange} // Update search input
                                    fullWidth
                                    margin="normal"
                                    type="text"
                                />
                            </FormControl>
                        </Form>
                        <div onClick={() => setActiveMenu("option1")} className={`${activeMenu === "option1" ? "active" : ""} mt-3`}>
                            <p className="mb-0"> Traditional</p>
                        </div>
                        <div onClick={() => setActiveMenu("option2")} className={`${activeMenu === "option2" ? "active" : ""} mt-3`}>
                            <p className="mb-0"> Third-party platforms</p>
                        </div>
                        <div onClick={() => setActiveMenu("option3")} className={`${activeMenu === "option3" ? "active" : ""} mt-3`}>
                            <p className="mb-0"> Crypto exchanges</p>
                        </div>
                    </div>
                    <div className="divider"></div>
                    <div className="content-area scrollbar-custom">
                        {renderContent()}
                    </div>
                </div>
            </Dialog>

            {selectedWidget && (
                <Dialog
                    open={!!selectedWidget}
                    onClose={handleCloseSecondDialog}
                    aria-labelledby="widget-dialog-title"
                    fullWidth
                    PaperProps={{
                        style: {
                            width: '600px',
                            maxWidth: '100%',
                        },
                    }}
                    className="widget-dialog"
                >
                    <DialogTitle id="widget-dialog-title" className="d-flex justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                            <img style={{ float: 'none', height: "18px", width: "9px" }} src={`${process.env.PUBLIC_URL}/images/left.svg`} alt="left" className="close-icon" role="button" 
                            onClick={handleCloseSecondDialog} />
                            <span style={{marginLeft:"15px"}}>Connect {selectedWidget.label}</span>
                        </div>
                        <img
                            style={{ height: "22px", width: "20px", cursor: "pointer" }}
                            src={`${process.env.PUBLIC_URL}/images/close.png`}
                            alt="close"
                            onClick={handleCloseSecondDialog}
                        />
                    </DialogTitle>
                    <DialogContent className="mt-2">
                        <div className="d-flex justify-content-center align-items-center mb-3">
                            <img
                                style={{ width: "50px", display: 'block' }}
                                src={`${process.env.PUBLIC_URL}/images/switch_acc/nodoji.svg`}
                                alt='nodoji'
                            />
                            <img
                                style={{ width: "40px", display: 'block', marginLeft:'30px', marginRight:'30px' }}
                                src={`${process.env.PUBLIC_URL}/images/switch_acc/switch_between.svg`}
                                alt='switch_between'
                            />
                            <img
                                style={{ width: "50px", display: 'block'}}
                                src={`${process.env.PUBLIC_URL}/images/switch_acc/${selectedWidget.src}`}
                                alt={selectedWidget.label}
                            />
                        </div>
                        <Form onSubmit={hendleKeySubmit}>
                            <div className="mb-2">
                                <span style={{fontSize: "16px"}}>API Key</span>
                            </div>
                            <Form.Group controlId="formBasicEmail" className="control">
                                <FormControl className="square-form-control-update m-0" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        placeholder={`Please enter your ${selectedWidget.label} API Key`}
                                        value={apiKey}
                                        onChange={(e) => setApiKey(e.target.value)}
                                        fullWidth
                                        margin="normal"
                                        type="text"
                                    />
                                </FormControl>
                            </Form.Group>
                            {/* {errors.api && <div className="text-danger mt-1">{errors.api}</div>} */}

                            {selectedWidget.label !== "Robinhood" && (
                                <div className="mt-3">
                                    <div className="mb-2">
                                        <span style={{ fontSize: "16px" }}>Secret Key</span>
                                    </div>
                                    <Form.Group controlId="formBasicEmail" className="control">
                                        <FormControl className="square-form-control-update m-0" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                placeholder={`Please enter your ${selectedWidget.label} Secret Key`}
                                                value={secretKey}
                                                onChange={(e) => setSecretKey(e.target.value)}
                                                fullWidth
                                                margin="normal"
                                                type="text"
                                            />
                                        </FormControl>
                                    </Form.Group>
                                    {/* {errors.secret && <div className="text-danger mt-1">{errors.secret}</div>} */}
                                </div>
                            )}
                            
                            <div className="mt-2 row justify-content-center">
                                <Button variant="primary" type="submit" style={{backgroundColor: '#48494C', textTransform: 'none'}} className="mt-5 w-55 p-2 theme-btn-email" disabled={loading}>
                                {loading ? 'Submitting...' : 'Submit'}
                                </Button>
                            </div>
                        </Form>
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
}

export default SwitchAccount;